var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 47C0 21.056 21.056 0 47 0C72.944 0 94 21.056 94 47C94 72.944 72.944 94 47 94C21.056 94 0 72.944 0 47ZM6.39999 47C6.39999 67.774 26.226 87.6 47 87.6C67.774 87.6 87.6 67.774 87.6 47C87.6 26.226 67.774 6.39999 47 6.39999C26.226 6.39999 6.39999 26.226 6.39999 47ZM38.9618 55.6376L28.3039 44.8615C27.5208 44.0697 26.2417 44.0701 25.459 44.8624L23.3875 46.9595C22.6183 47.7381 22.6179 48.9904 23.3866 49.7696L38.9618 65.5577C39.7446 66.3512 41.0251 66.3517 41.8084 65.5587L71.6174 35.3822C72.3846 34.6055 72.3872 33.3569 71.6232 32.5771L69.5417 30.4523C68.7598 29.6541 67.4755 29.6514 66.6902 30.4464L41.8066 55.6368C41.024 56.4291 39.7449 56.4295 38.9618 55.6376Z",
    fill: "#01D83D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.2342d486.svg";
export { ForwardRef as ReactComponent };